import type { SupportedLocale } from '@erp/shared';

interface SettingsUsabilityCopy {
  search: string;
  placeholder: string;
  hint: string;
  clear: string;
  results: string;
  noResults: string;
  noResultsHint: string;
  groups: {
    basics: string;
    sales: string;
    finance: string;
    communication: string;
    team: string;
    system: string;
  };
  customFields: string;
  customFieldsDescription: string;
}

export const settingsUsabilityTranslations: Record<SupportedLocale, SettingsUsabilityCopy> = {
  de: {
    search: 'Einstellungen suchen',
    placeholder: 'Zum Beispiel: Zusatzfelder, Preise oder Benutzer',
    hint: 'Suchen Sie nach Ihrer Aufgabe oder wählen Sie unten einen Bereich.',
    clear: 'Suche zurücksetzen',
    results: '{{count}} passende Bereiche',
    noResults: 'Keine passenden Einstellungen',
    noResultsHint: 'Versuchen Sie einen kürzeren Begriff oder setzen Sie die Suche zurück.',
    groups: {
      basics: 'Unternehmen und Stammdaten',
      sales: 'Verkauf und Belege',
      finance: 'Finanzen',
      communication: 'Kommunikation',
      team: 'Team und Kommunikation',
      system: 'Systemverwaltung',
    },
    customFields: 'Zusatzfelder',
    customFieldsDescription:
      'Eigene Angaben für Kunden, Artikel und Belege anlegen und übersichtlich gruppieren.',
  },
  en: {
    search: 'Search settings',
    placeholder: 'For example: custom fields, prices or users',
    hint: 'Search for your task or choose an area below.',
    clear: 'Clear search',
    results: '{{count}} matching areas',
    noResults: 'No matching settings',
    noResultsHint: 'Try a shorter term or clear the search.',
    groups: {
      basics: 'Company and master data',
      sales: 'Sales and documents',
      finance: 'Finance',
      communication: 'Communication',
      team: 'Team and communication',
      system: 'System administration',
    },
    customFields: 'Custom fields',
    customFieldsDescription:
      'Add and organise your own information for customers, products and documents.',
  },
  fr: {
    search: 'Rechercher des paramètres',
    placeholder: 'Par exemple : champs personnalisés, prix ou utilisateurs',
    hint: 'Recherchez votre tâche ou choisissez une rubrique ci-dessous.',
    clear: 'Effacer la recherche',
    results: '{{count}} rubriques correspondantes',
    noResults: 'Aucun paramètre correspondant',
    noResultsHint: 'Essayez un terme plus court ou effacez la recherche.',
    groups: {
      basics: 'Société et données de base',
      sales: 'Ventes et documents',
      finance: 'Finances',
      communication: 'Communication',
      team: 'Équipe et communication',
      system: 'Administration du système',
    },
    customFields: 'Champs personnalisés',
    customFieldsDescription:
      'Ajoutez et regroupez vos propres informations pour les clients, articles et documents.',
  },
  es: {
    search: 'Buscar ajustes',
    placeholder: 'Por ejemplo: campos personalizados, precios o usuarios',
    hint: 'Busque su tarea o elija una sección a continuación.',
    clear: 'Borrar búsqueda',
    results: '{{count}} secciones coincidentes',
    noResults: 'No hay ajustes coincidentes',
    noResultsHint: 'Pruebe un término más corto o borre la búsqueda.',
    groups: {
      basics: 'Empresa y datos maestros',
      sales: 'Ventas y documentos',
      finance: 'Finanzas',
      communication: 'Comunicación',
      team: 'Equipo y comunicación',
      system: 'Administración del sistema',
    },
    customFields: 'Campos personalizados',
    customFieldsDescription:
      'Añada y organice información propia para clientes, artículos y documentos.',
  },
  tr: {
    search: 'Ayarlarda ara',
    placeholder: 'Örneğin: ek alanlar, fiyatlar veya kullanıcılar',
    hint: 'Yapmak istediğiniz işi arayın veya aşağıdan bir bölüm seçin.',
    clear: 'Aramayı temizle',
    results: '{{count}} eşleşen bölüm',
    noResults: 'Eşleşen ayar bulunamadı',
    noResultsHint: 'Daha kısa bir kelime deneyin veya aramayı temizleyin.',
    groups: {
      basics: 'Şirket ve ana veriler',
      sales: 'Satış ve belgeler',
      finance: 'Finans',
      communication: 'İletişim',
      team: 'Ekip ve iletişim',
      system: 'Sistem yönetimi',
    },
    customFields: 'Ek alanlar',
    customFieldsDescription:
      'Müşteriler, ürünler ve belgeler için kendi bilgilerinizi ekleyin ve düzenli gruplara ayırın.',
  },
};
